import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { CardDataController } from '@colonist/game-card-types';
import { ArrayUtils } from '@colonist/utils';
import { UIGameBeginnerModeCardsHelper } from '../ui_game_beginner_mode/ui_game_beginner_mode_helpers/UIGameBeginnerModeCardsHelper.ts';
import { BeginnerModeConstants } from '@colonist/game-beginner-mode';
import { PIXI } from '@colonist/pixi';
import { PlayerColor, TurnState } from '@colonist/game-states';
import { Point } from '@colonist/game-mechanic-validators';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { getGlobalPositionOfPlayerCard, getPointPositionFromBank, getPointPositionFromPlayerInventory, getCardDimensionsFromPlayerInventory } from '@colonist/ui-game';
import { ModeSettingEnum } from '@colonist/types';
export class UIGameCardController {
    getCardInventory() {
        const cardsInInventory = this.uiGameManager.gameStore.getState().gameCardInventory.cardInventory;
        const cardsAnimatingToMyHand = this.cardsAnimatingToMyHand.map((card)=>card.cardEnum);
        return [
            ...cardsInInventory,
            ...cardsAnimatingToMyHand
        ];
    }
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.GivePlayerCardFromTile:
                this.addCardsFromTile(data);
                break;
            case UIGameEventEnums.ExchangeCards:
                this.exchangeCards(data);
                break;
            case UIGameEventEnums.PlayerControllerStateUpdated:
                this.onPlayerControllerStateUpdated();
                break;
            case UIGameEventEnums.TileNumberAnimationEnd:
                this.distributePendingCards();
                break;
            default:
                break;
        }
    }
    initBeginnerModeHelper() {
        this.beginnerModeHelper = new UIGameBeginnerModeCardsHelper(this.uiGameManager);
    }
    onPlayerControllerStateUpdated() {
        var _this_beginnerModeHelper;
        const myCurrentCardEnums = this.getCardInventory().sort();
        (_this_beginnerModeHelper = this.beginnerModeHelper) === null || _this_beginnerModeHelper === void 0 ? void 0 : _this_beginnerModeHelper.addPendingCardsToMyCurrentCardEnums(myCurrentCardEnums, this.cardsToBeAddedFromTile);
    }
    highlightTileDuringInitialPlacement(tileIndex) {
        if (this.uiGameManager.gameController.currentState.turnState != TurnState.InitialPlacement) return;
        const tileToHighlight = this.uiGameManager.mapController.tileViews[tileIndex];
        const animationDurationInSeconds = 0.5;
        tileToHighlight.highlightTileForTime(animationDurationInSeconds);
    }
    distributePendingCards() {
        const tileIndexToAmountOfCardsProducedFromTile = this.getTileIndexToAmountOfCardsProduced();
        const tileIndexToCardIndexMap = new Map();
        for (const transaction of this.cardsToBeAddedFromTile){
            if (!tileIndexToCardIndexMap.has(transaction.tileIndex)) tileIndexToCardIndexMap.set(transaction.tileIndex, 0);
            var _tileIndexToCardIndexMap_get;
            const cardIndex = (_tileIndexToCardIndexMap_get = tileIndexToCardIndexMap.get(transaction.tileIndex)) !== null && _tileIndexToCardIndexMap_get !== void 0 ? _tileIndexToCardIndexMap_get : 0;
            var _tileIndexToAmountOfCardsProducedFromTile_get;
            const totalNumberOfCardsProducedFromTile = (_tileIndexToAmountOfCardsProducedFromTile_get = tileIndexToAmountOfCardsProducedFromTile.get(transaction.tileIndex)) !== null && _tileIndexToAmountOfCardsProducedFromTile_get !== void 0 ? _tileIndexToAmountOfCardsProducedFromTile_get : 0;
            this.addCardFromTile([
                transaction.card
            ], transaction.tileIndex, transaction.owner, cardIndex, totalNumberOfCardsProducedFromTile);
            tileIndexToCardIndexMap.set(transaction.tileIndex, cardIndex + 1);
        }
        this.cardsToBeAddedFromTile.length = 0;
    }
    getTileIndexToAmountOfCardsProduced() {
        const tileIndexToAmountOfCardsProduced = new Map();
        for (const transaction of this.cardsToBeAddedFromTile){
            if (!tileIndexToAmountOfCardsProduced.has(transaction.tileIndex)) tileIndexToAmountOfCardsProduced.set(transaction.tileIndex, 0);
            var _tileIndexToAmountOfCardsProduced_get;
            const cardCount = (_tileIndexToAmountOfCardsProduced_get = tileIndexToAmountOfCardsProduced.get(transaction.tileIndex)) !== null && _tileIndexToAmountOfCardsProduced_get !== void 0 ? _tileIndexToAmountOfCardsProduced_get : 0;
            tileIndexToAmountOfCardsProduced.set(transaction.tileIndex, cardCount + 1);
        }
        return tileIndexToAmountOfCardsProduced;
    }
    exchangeCards(exchangeData) {
        var _this_beginnerModeHelper;
        const makeCardsFlyToRobber = ((_this_beginnerModeHelper = this.beginnerModeHelper) === null || _this_beginnerModeHelper === void 0 ? void 0 : _this_beginnerModeHelper.shouldCardsFlyToRobber) && exchangeData.givingPlayer == this.uiGameManager.gameController.myColor;
        if (makeCardsFlyToRobber) {
            this.giveCardsToRobber(exchangeData);
        } else {
            this.playerExchange(exchangeData.receivingPlayer, exchangeData.givingPlayer, exchangeData.givingCards);
        }
        this.playerExchange(exchangeData.givingPlayer, exchangeData.receivingPlayer, exchangeData.receivingCards);
    }
    addCardsFromTile(transactions) {
        this.cardsToBeAddedFromTile.push(...transactions);
        if (this.shouldDisplayBeginnerModeCardAnimation()) return;
        this.distributePendingCards();
    }
    shouldDisplayBeginnerModeCardAnimation() {
        const isBeginnerMode = this.beginnerModeHelper != undefined;
        if (!isBeginnerMode) return false;
        const isInitialResourceDistributionInBeginnerMode = this.uiGameManager.gameController.currentState.turnState == TurnState.InitialPlacement;
        return !isInitialResourceDistributionInBeginnerMode;
    }
    playerExchange(receivingPlayer, givingPlayer, cards) {
        for(let i = 0; i < cards.length; i++){
            const cardToGive = cards[i];
            const startPoint = this.getCardAnimationPointForPlayer(givingPlayer, cardToGive);
            const endPoint = this.getCardAnimationPointForPlayer(receivingPlayer, cardToGive);
            const delay = UIGameCardController.CARD_ANIMATION_DELAY + i * UIGameCardController.CARD_ANIMATION_DELAY_PER_CARD;
            this.createCardAnimation(cardToGive, startPoint, endPoint, givingPlayer, receivingPlayer, {
                delay: delay
            });
        }
    }
    getCardAnimationPointForPlayer(player, cardEnum) {
        const isBankTrade = player == PlayerColor.None;
        var _getPointPositionFromBank;
        if (isBankTrade) return (_getPointPositionFromBank = getPointPositionFromBank(cardEnum)) !== null && _getPointPositionFromBank !== void 0 ? _getPointPositionFromBank : new Point(0, 0);
        const isCardComingToMyHand = player == this.uiGameManager.gameController.myColor;
        if (isCardComingToMyHand) {
            const pointFromDOMInventory = getPointPositionFromPlayerInventory(cardEnum);
            if (!pointFromDOMInventory) return new Point(0, 0);
            return pointFromDOMInventory;
        }
        const isResourceCard = CardDataController.isResourceCard(cardEnum);
        const opponentPoint = this.getPointFromPlayer(player, isResourceCard);
        if (opponentPoint == undefined) return new Point(0, 0);
        return opponentPoint;
    }
    // eslint-disable-next-line class-methods-use-this
    getPointFromPlayer(player, isResourceCard) {
        var _getGlobalPositionOfPlayerCard;
        return (_getGlobalPositionOfPlayerCard = getGlobalPositionOfPlayerCard(player, isResourceCard)) !== null && _getGlobalPositionOfPlayerCard !== void 0 ? _getGlobalPositionOfPlayerCard : new Point(0, 0);
    }
    giveCardsToRobber(exchangeData) {
        if (this.robberState == undefined) return;
        const robberTileIndex = this.robberState == undefined ? 11 : this.robberState.locationTileIndex;
        const cards = exchangeData.givingCards;
        for (const card of cards){
            const endPoint = this.getPointFromMap(robberTileIndex);
            const startPoint = this.getCardAnimationPointForPlayer(this.uiGameManager.gameController.myColor, card);
            this.createCardAnimation(card, startPoint, endPoint, this.uiGameManager.gameController.myColor, PlayerColor.None);
        }
    }
    addCardFromTile(cards, tileIndex, toPlayer, cardIndex, totalNumberOfCardsProducedFromTile) {
        this.highlightTileDuringInitialPlacement(tileIndex);
        const animationStartPoint = this.getPointFromMap(tileIndex);
        for (const cardEnum of cards){
            const animationEndPoint = this.getCardAnimationPointForPlayer(toPlayer, cardEnum);
            if (this.beginnerModeHelper == undefined) {
                const delay = UIGameCardController.CARD_ANIMATION_DELAY + cardIndex * UIGameCardController.CARD_ANIMATION_DELAY_PER_CARD;
                this.createCardAnimation(cardEnum, animationStartPoint, animationEndPoint, PlayerColor.None, toPlayer, {
                    delay: delay
                });
                return;
            }
            const orderOfThisCard = cardIndex;
            const amountOfCardsProducedFromTile = totalNumberOfCardsProducedFromTile !== null && totalNumberOfCardsProducedFromTile !== void 0 ? totalNumberOfCardsProducedFromTile : 1;
            const cardDimensions = getCardDimensionsFromPlayerInventory();
            const cardW = cardDimensions.width;
            const riseAnimationEndPointX = animationStartPoint.x + cardW * (orderOfThisCard - (amountOfCardsProducedFromTile - 1) / 2);
            const riseAnimationEndPoint = new Point(riseAnimationEndPointX, animationStartPoint.y);
            this.addCardFromTileWithRiseAnimation(cardEnum, riseAnimationEndPoint, animationEndPoint, toPlayer);
        }
    }
    addCardFromTileWithRiseAnimation(cardEnum, cardAnimationStartPoint, cardAnimationEndPoint, toPlayer) {
        var _this_beginnerModeHelper;
        const riseAnimationSpeed = 0.5;
        const cardDimensions = getCardDimensionsFromPlayerInventory();
        const cardH = cardDimensions.height;
        const riseAnimationEndPoint = new Point(cardAnimationStartPoint.x, cardAnimationStartPoint.y - cardH);
        var _this_beginnerModeHelper_cardFlyAnimationWaitMS;
        const cardAnimationWaitMS = (_this_beginnerModeHelper_cardFlyAnimationWaitMS = (_this_beginnerModeHelper = this.beginnerModeHelper) === null || _this_beginnerModeHelper === void 0 ? void 0 : _this_beginnerModeHelper.cardFlyAnimationWaitMS) !== null && _this_beginnerModeHelper_cardFlyAnimationWaitMS !== void 0 ? _this_beginnerModeHelper_cardFlyAnimationWaitMS : 1000;
        const afterRiseAnimation = ()=>{
            this.createCardAnimation(cardEnum, riseAnimationEndPoint, cardAnimationEndPoint, PlayerColor.None, toPlayer, {
                delay: cardAnimationWaitMS
            });
        };
        const animationSpeed = BeginnerModeConstants.BASE_WAIT_MS_FOR_CARD_FLY_ANIMATION / cardAnimationWaitMS * riseAnimationSpeed;
        this.createCardAnimation(cardEnum, cardAnimationStartPoint, riseAnimationEndPoint, PlayerColor.None, PlayerColor.None, {
            speed: animationSpeed,
            onComplete: afterRiseAnimation
        });
    }
    getPointFromMap(tileIndex) {
        const half = 2;
        const tile = this.uiGameManager.mapController.tileViews[tileIndex];
        const margin = this.uiGameManager.canvasController.margin;
        const cardDimensions = getCardDimensionsFromPlayerInventory();
        const cardW = cardDimensions.width;
        const cardH = cardDimensions.height;
        const x = tile.x + tile.width / half - cardW / half + margin;
        const y = tile.y + tile.height / half - cardH / half;
        const worldPoint = new PIXI.Point(x, y);
        return this.uiGameManager.mapController.worldToScreenPoint(worldPoint);
    }
    removeMyCardForAnimation(cardEnum) {
        const isRemovedFromInventory = this.removeMyCardForAnimationFromInventory(cardEnum);
        if (isRemovedFromInventory) return;
        const isRemovedFromFlyingCards = this.removeMyCardForAnimationFromFlyingCards(cardEnum);
        if (isRemovedFromFlyingCards) return;
        // eslint-disable-next-line no-console
        console.error('Card not found in inventory or flying cards for animation', cardEnum);
    }
    removeMyCardForAnimationFromInventory(cardEnum) {
        const cardInventory = this.uiGameManager.gameStore.getState().gameCardInventory.cardInventory;
        if (cardInventory.includes(cardEnum)) {
            return true;
        }
        return false;
    }
    removeMyCardForAnimationFromFlyingCards(cardEnum) {
        const existingFlyingCard = this.cardsAnimatingToMyHand.find((card)=>card.cardEnum === cardEnum);
        if (existingFlyingCard) {
            this.uiGameManager.gameStore.getState().gameCardAnimator.forceAnimationComplete(existingFlyingCard.animationId);
            return this.removeMyCardForAnimationFromInventory(cardEnum);
        }
        return false;
    }
    createCardAnimation(cardEnum, startPoint, endPoint, startPlayer, endPlayer, options) {
        const animationId = this.nextAnimationId;
        this.nextAnimationId += 1;
        const isAnimatingToMyHand = endPlayer == this.uiGameManager.gameController.myColor && !this.uiGameManager.gameController.isPlayerSpectator;
        if (isAnimatingToMyHand) this.cardsAnimatingToMyHand.push({
            cardEnum: cardEnum,
            animationId: animationId
        });
        const isAnimatingFromMyHand = startPlayer == this.uiGameManager.gameController.myColor && !this.uiGameManager.gameController.isPlayerSpectator;
        if (isAnimatingFromMyHand) this.removeMyCardForAnimation(cardEnum);
        const onComplete = (id)=>{
            var _options_onComplete;
            this.uiGameManager.gameStore.getState().gameCardAnimator.removeCard(id);
            options === null || options === void 0 ? void 0 : (_options_onComplete = options.onComplete) === null || _options_onComplete === void 0 ? void 0 : _options_onComplete.call(options);
            this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.CardAnimationEnd);
            if (isAnimatingToMyHand) {
                const existingFlyingCard = this.cardsAnimatingToMyHand.find((card)=>card.animationId === animationId);
                if (existingFlyingCard) ArrayUtils.removeElementFromArray(this.cardsAnimatingToMyHand, existingFlyingCard);
            }
        };
        const appSize = Math.max(this.uiGameManager.canvasController.appW, this.uiGameManager.canvasController.appH);
        const speedForResolution = appSize / 2000;
        const speedForGameMode = UIGameCardController.getSpeedForGameMode(this.uiGameManager.gameController.gameSettings.modeSetting);
        var _options_speed;
        const speed = ((_options_speed = options === null || options === void 0 ? void 0 : options.speed) !== null && _options_speed !== void 0 ? _options_speed : 1) * speedForResolution * speedForGameMode;
        var _options_delay;
        this.uiGameManager.gameStore.getState().gameCardAnimator.addCard({
            id: animationId,
            card: {
                cardEnum: cardEnum
            },
            isAnimatingToMyHand: isAnimatingToMyHand,
            from: startPoint,
            to: endPoint,
            speed: speed,
            delay: (_options_delay = options === null || options === void 0 ? void 0 : options.delay) !== null && _options_delay !== void 0 ? _options_delay : UIGameCardController.CARD_ANIMATION_DELAY,
            onComplete: onComplete
        });
    }
    static getSpeedForGameMode(mode) {
        switch(mode){
            case ModeSettingEnum.ColonistRush4P:
                return 1.25;
            default:
                return 1;
        }
    }
    constructor(uiGameManager, robberState){
        this.nextAnimationId = 0;
        this.cardsAnimatingToMyHand = [];
        this.cardsToBeAddedFromTile = [];
        this.uiGameManager = uiGameManager;
        this.robberState = robberState;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
    }
}
UIGameCardController.CARD_ANIMATION_DELAY = 100;
UIGameCardController.CARD_ANIMATION_DELAY_PER_CARD = 15;
